<template>

  <swoutCredito />

</template>

<script>
import swoutCredito from '../components/pratiche/swoutCredito.vue'

export default {
  components: {
    swoutCredito
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
